import React from "react";

/**
 * Nero Oro skeleton loader with a subtle gold shimmer.
 * Usage:
 *   <Skeleton className="h-4 w-32" />
 *   <SkeletonLine width="60%" />
 *   <SkeletonRow columns={4} />
 */
export function Skeleton({ className = "", style = {}, ...rest }) {
    return (
        <div
            className={`bc-skeleton ${className}`}
            style={style}
            aria-busy="true"
            aria-live="polite"
            {...rest}
        />
    );
}

export function SkeletonLine({ width = "100%", height = 12, className = "", style = {} }) {
    return <Skeleton className={className} style={{ width, height, ...style }} />;
}

export function SkeletonRow({ columns = 4, className = "" }) {
    return (
        <div className={`grid gap-4 ${className}`} style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}>
            {Array.from({ length: columns }).map((_, i) => (
                <SkeletonLine key={i} height={14} width={`${60 + Math.random() * 30}%`} />
            ))}
        </div>
    );
}

export function SkeletonCard({ lines = 3, className = "" }) {
    return (
        <div className={`bc-card ${className}`}>
            <SkeletonLine width="45%" height={18} />
            <div className="mt-4 space-y-3">
                {Array.from({ length: lines }).map((_, i) => (
                    <SkeletonLine key={i} width={`${70 + Math.random() * 25}%`} height={12} />
                ))}
            </div>
        </div>
    );
}
